import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { SupportChat } from './app/core/util/support-chat';

if (environment.production) {
  enableProdMode();
}

// Before the router reads the URL: a website visitor's ?support_handoff= code is kept for the tab
// and taken out of the address bar, so the router never puts it back (SupportChat).
SupportChat.captureHandoff();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
